import { FaStar } from "react-icons/fa";
import Button from "../Button";
import AvatarImg from "../../../assets/images/avatar.png";

const MentorCard = ({
  title = "Your Mentor",
  name,
  role,
  image,
  rating = 5,
  onSchedule,
}) => {
  return (
    <div className="rounded-lg border border-primary">
      <div className="p-4">
        <h5 className="text-light fw-bold mb-3">{title}</h5>

        <div className="text-center">
          <img
            src={AvatarImg}
            alt={name}
            className="rounded-circle mb-3"
            style={{ width: "60px", height: "60px" }}
          />
          <h6 className="text-light">{name}</h6>
          <small className="text-white">{role}</small>

          {/* Rating */}
          <div className="d-flex justify-content-center mt-2 mb-3">
            {[...Array(rating)].map((_, index) => (
              <FaStar key={index} size={12} className="text-accent mx-1" />
            ))}
          </div>

          {/* Button */}
          <Button
            variant="gradient"
            onClick={onSchedule}
            fullWidth
          >
            Schedule Session
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MentorCard;